import React from 'react';
import { classes } from 'typestyle';
import { dialogActionsContainer } from './Dialog.styles';

export function DialogActionContainer({ className, ...props }: React.DialogHTMLAttributes<HTMLDivElement>) {
  return <div className={classes(dialogActionsContainer, className)} {...props} />;
}
